import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card } from '../components/ui/Card';
import { Building, Users, ShieldCheck, Activity } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function AboutPage() {
  const {
    t
  } = useLanguage();
  return <div className="pt-20" data-id="element-373">
      {/* Hero */}
      <div className="bg-caces-navy text-white py-20" data-id="element-374">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-375">
          <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4" data-id="element-376">
            {t.about.hero.title}
          </h1>
          <p className="text-xl text-caces-light max-w-2xl mx-auto" data-id="element-377">
            {t.about.hero.subtitle}
          </p>
        </div>
      </div>

      {/* Who We Are */}
      <section className="py-16 bg-white" data-id="element-378">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-380">
            <div data-id="element-381">
              <h2 className="font-serif text-3xl font-bold text-caces-navy mb-6" data-id="element-382">
                {t.about.who.title}
              </h2>
              <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-383">
                {t.about.who.p1}
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-384">{t.about.who.p2}</p>
            </div>
            <div className="bg-gray-100 rounded-2xl h-80 flex items-center justify-center" data-id="element-385">
              <Building size={64} className="text-gray-300" data-id="element-386" />
            </div>
          </div>
        </div>
      </section>

      {/* Medical Model */}
      <section className="py-16 bg-gray-50" data-id="element-387">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-388">
          <SectionHeading title={t.about.model.title} subtitle={t.about.model.subtitle} data-id="element-389" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8" data-id="element-390">
            <Card className="p-8" data-id="element-391">
              <Users className="w-10 h-10 text-caces-accent mb-4" data-id="element-392" />
              <h3 className="font-serif text-xl font-bold text-caces-navy mb-3" data-id="element-393">
                {t.about.model.specialists.title}
              </h3>
              <p className="text-gray-600" data-id="element-394">{t.about.model.specialists.desc}</p>
            </Card>
            <Card className="p-8" data-id="element-395">
              <ShieldCheck className="w-10 h-10 text-caces-accent mb-4" data-id="element-396" />
              <h3 className="font-serif text-xl font-bold text-caces-navy mb-3" data-id="element-397">
                {t.about.model.support.title}
              </h3>
              <p className="text-gray-600" data-id="element-398">{t.about.model.support.desc}</p>
            </Card>
            <Card className="p-8" data-id="element-399">
              <Activity className="w-10 h-10 text-caces-accent mb-4" data-id="element-400" />
              <h3 className="font-serif text-xl font-bold text-caces-navy mb-3" data-id="element-401">
                {t.about.model.patient.title}
              </h3>
              <p className="text-gray-600" data-id="element-402">{t.about.model.patient.desc}</p>
            </Card>
          </div>
        </div>
      </section>

      {/* Infrastructure */}
      <section className="py-16 bg-white" data-id="element-403">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-404">
          <SectionHeading title={t.about.infra.title} data-id="element-405" />

          <div className="space-y-12" data-id="element-406">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-407">
              <div className="w-full md:w-1/2 h-64 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-408">
                <span className="text-gray-400" data-id="element-409">
                  Operating Room Image Placeholder
                </span>
              </div>
              <div className="w-full md:w-1/2" data-id="element-410">
                <h3 className="font-serif text-2xl font-bold text-caces-navy mb-4" data-id="element-411">
                  {t.about.infra.suites.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-412">
                  {t.about.infra.suites.desc}
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-413">
              <div className="w-full md:w-1/2 h-64 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-414">
                <span className="text-gray-400" data-id="element-415">
                  Hospitalization Room Image Placeholder
                </span>
              </div>
              <div className="w-full md:w-1/2" data-id="element-416">
                <h3 className="font-serif text-2xl font-bold text-caces-navy mb-4" data-id="element-417">
                  {t.about.infra.rooms.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-418">
                  {t.about.infra.rooms.desc}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Management */}
      <section className="py-16 bg-caces-navy text-white" data-id="element-419">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-420">
          <h2 className="font-serif text-3xl font-bold mb-6" data-id="element-421">
            {t.about.management.title}
          </h2>
          <p className="text-lg text-caces-light leading-relaxed mb-8" data-id="element-422">
            {t.about.management.desc}
          </p>
          <div className="p-4 bg-white/10 rounded-lg inline-block" data-id="element-423">
            <p className="text-sm font-medium" data-id="element-424">{t.about.management.note}</p>
          </div>
        </div>
      </section>
    </div>;
}